import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

const routes: RouteRecordRaw = {
  path: '/',
  component: () => import('@/views/index.vue'),
  name: 'Dashboard',
  meta: {
    title: $t('route.dashboard'),
    icon: 'dashboard',
    singleMenu: true,
  },
}

export default routes
